<template>
  <div class="cy-date-time-picker">
    <el-date-picker
      ref="cy-date-time-picker"
      v-model="timeRange"
      type="daterange"
      :format="format"
      :picker-options="realPickerOptions"
      :range-separator="separator"
      start-placeholder="开始日期"
      end-placeholder="结束日期"
      :align="align"
      popper-class="cy-date-time-picker"
      :default-time="['00:00:00', '23:59:59']"
      @change="timeChange"
    />
    <i
      v-show="isShowIcon"
      :class="['icon', iconClass]"
      @click="openPicker"
    />
  </div>
</template>

<script>
/**
 * defaultTime：可以为字符串（24h、last_1d、last_7d、last_30d），也可以为数组（[2020-01-06 00:00:00，2020-01-07 23:59:59]）
 */
import { getTimeParamCy, timeFormat } from '@common/util.js'
export default {
  props: {
    defaultTime: {
      type: [String, Array],
      default: () => 'last_1d'
    },
    separator: {
      type: String,
      default: () => '至'
    },
    align: {
      type: String,
      default: () => 'right'
    },
    // 近7天、昨天、近30天事是否包含当前时间
    isContainsCurTime: {
      type: Boolean,
      default: () => false
    },
    format: {
      type: String,
      default: () => 'yyyy-MM-dd'
    },
    isShowShortCuts: {
      type: Boolean,
      default: true
    },
    isShowIcon: {
      type: Boolean,
      default: true
    },
    iconClass: {
      type: String,
      default: 'icon-cy-dateTime'
    },
    // isContainsCurTime为true的时候可单独设置昨天的结束时间
    yesterdayIsContainsCurTime: {
      type: Boolean,
      default: true
    }
  },
  computed: {
    trackpickerOptions() {
      return {
        shortcuts: [
          {
            text: '24小时',
            onClick(picker) {
              // 添加高亮状态
              let btns = picker.$el.querySelectorAll(
                '.el-picker-panel__shortcut'
              )
              for (let i = 0, len = btns.length; i < len; i++) {
                if (btns[i].innerText === '24小时') {
                  btns[i].classList.add('active')
                } else {
                  btns[i].classList.remove('active')
                }
              }
              const start = new Date(getTimeParamCy('24h').startTime)
              const end = new Date(getTimeParamCy('24h').endTime)
              picker.$emit('pick', [start, end])
            }
          },
          {
            text: '昨天',
            onClick(picker) {
              let btns = picker.$el.querySelectorAll(
                '.el-picker-panel__shortcut'
              )
              for (let i = 0, len = btns.length; i < len; i++) {
                if (btns[i].innerText === '昨天') {
                  btns[i].classList.add('active')
                } else {
                  btns[i].classList.remove('active')
                }
              }
              const start = new Date(getTimeParamCy('last_1d').startTime)
              const end = this.yesterdayIsContainsCurTime
                ? new Date()
                : new Date(getTimeParamCy('last_1d').endTime)
              picker.$emit('pick', [start, end])
            }
          },
          {
            text: '7天',
            onClick(picker) {
              let btns = picker.$el.querySelectorAll(
                '.el-picker-panel__shortcut'
              )
              for (let i = 0, len = btns.length; i < len; i++) {
                if (btns[i].innerText === '7天') {
                  btns[i].classList.add('active')
                } else {
                  btns[i].classList.remove('active')
                }
              }
              const start = new Date(getTimeParamCy('last_7d').startTime)
              const end = new Date()
              picker.$emit('pick', [start, end])
            }
          },
          {
            text: '30天',
            onClick(picker) {
              let btns = picker.$el.querySelectorAll(
                '.el-picker-panel__shortcut'
              )
              for (let i = 0, len = btns.length; i < len; i++) {
                if (btns[i].innerText === '30天') {
                  btns[i].classList.add('active')
                } else {
                  btns[i].classList.remove('active')
                }
              }
              const start = new Date(getTimeParamCy('last_30d').startTime)
              const end = new Date()
              picker.$emit('pick', [start, end])
            }
          }
        ],
        onPick({ maxDate, minDate }) {
          // 如果是表盘选中时间，清空快捷按钮的状态
          if (maxDate && minDate) {
            let btns = document.querySelectorAll(
              '.cy-date-time-picker .el-picker-panel__shortcut'
            )
            for (let i = 0, len = btns.length; i < len; i++) {
              btns[i].classList.remove('active')
            }
          }
        },
        disabledDate(time) {
          let now = Date.now()
          // 当前日期后延一天的凌晨时刻
          let targetTime = new Date(now + 1 * 24 * 60 * 60 * 1000).setHours(
            0,
            0,
            0,
            0
          )
          return time >= targetTime
        }
      }
    },
    realPickerOptions() {
      return this.isShowShortCuts
        ? this.isContainsCurTime
          ? this.trackpickerOptions
          : this.pickerOptions
        : {}
    }
  },
  data() {
    return {
      timeRange: [],
      pickerOptions: {
        shortcuts: [
          {
            text: '24小时',
            onClick(picker) {
              // 添加高亮状态
              let btns = picker.$el.querySelectorAll(
                '.el-picker-panel__shortcut'
              )
              for (let i = 0, len = btns.length; i < len; i++) {
                if (btns[i].innerText === '24小时') {
                  btns[i].classList.add('active')
                } else {
                  btns[i].classList.remove('active')
                }
              }
              const start = new Date(getTimeParamCy('24h').startTime)
              const end = new Date(getTimeParamCy('24h').endTime)
              picker.$emit('pick', [start, end])
            }
          },
          {
            text: '昨天',
            onClick(picker) {
              let btns = picker.$el.querySelectorAll(
                '.el-picker-panel__shortcut'
              )
              for (let i = 0, len = btns.length; i < len; i++) {
                if (btns[i].innerText === '昨天') {
                  btns[i].classList.add('active')
                } else {
                  btns[i].classList.remove('active')
                }
              }
              const start = new Date(getTimeParamCy('last_1d').startTime)
              const end = new Date(getTimeParamCy('last_1d').endTime)
              picker.$emit('pick', [start, end])
            }
          },
          {
            text: '7天',
            onClick(picker) {
              let btns = picker.$el.querySelectorAll(
                '.el-picker-panel__shortcut'
              )
              for (let i = 0, len = btns.length; i < len; i++) {
                if (btns[i].innerText === '7天') {
                  btns[i].classList.add('active')
                } else {
                  btns[i].classList.remove('active')
                }
              }
              const start = new Date(getTimeParamCy('last_7d').startTime)
              const end = new Date(getTimeParamCy('last_7d').endTime)
              picker.$emit('pick', [start, end])
            }
          },
          {
            text: '30天',
            onClick(picker) {
              let btns = picker.$el.querySelectorAll(
                '.el-picker-panel__shortcut'
              )
              for (let i = 0, len = btns.length; i < len; i++) {
                if (btns[i].innerText === '30天') {
                  btns[i].classList.add('active')
                } else {
                  btns[i].classList.remove('active')
                }
              }
              const start = new Date(getTimeParamCy('last_30d').startTime)
              const end = new Date(getTimeParamCy('last_30d').endTime)
              picker.$emit('pick', [start, end])
            }
          }
        ],
        onPick({ maxDate, minDate }) {
          // 如果是表盘选中时间，清空快捷按钮的状态
          if (maxDate && minDate) {
            let btns = document.querySelectorAll(
              '.cy-date-time-picker .el-picker-panel__shortcut'
            )
            for (let i = 0, len = btns.length; i < len; i++) {
              btns[i].classList.remove('active')
            }
          }
        },
        disabledDate(time) {
          let now = Date.now()
          // 当前日期后延一天的凌晨时刻
          let targetTime = new Date(now + 1 * 24 * 60 * 60 * 1000).setHours(
            0,
            0,
            0,
            0
          )
          return time >= targetTime
        }
      }
    }
  },
  watch: {
    defaultTime(newVal, oldVal) {
      let btns = document.querySelectorAll(
        '.cy-date-time-picker .el-picker-panel__shortcut'
      )
      for (let i = 0, len = btns.length; i < len; i++) {
        btns[i].classList.remove('active')
      }
      if (Object.prototype.toString.call(newVal) === '[object String]') {
        this.timeRange = [
          getTimeParamCy(newVal).startTime,
          getTimeParamCy(newVal).endTime
        ]
        if (this.isContainsCurTime) {
          this.timeRange = [getTimeParamCy(newVal).startTime, new Date()]
        }
      } else {
        this.timeRange = [newVal[0], newVal[1]]
      }
    }
  },
  mounted() {
    if (
      Object.prototype.toString.call(this.defaultTime) === '[object String]'
    ) {
      this.timeRange = [
        getTimeParamCy(this.defaultTime).startTime,
        getTimeParamCy(this.defaultTime).endTime
      ]
      if (this.isContainsCurTime) {
        this.timeRange = [
          getTimeParamCy(this.defaultTime).startTime,
          new Date()
        ]
      }
    } else {
      this.timeRange = [this.defaultTime[0], this.defaultTime[1]]
    }
  },
  methods: {
    timeChange(timeRange) {
      this.$emit('timeChange', [
        timeFormat(timeRange[0]),
        timeFormat(timeRange[1])
      ])
    },
    openPicker() {
      this.$refs['cy-date-time-picker'].focus()
    }
  }
}
</script>

<style lang="scss">
.cy-date-time-picker {
  position: relative;
  &.el-picker-panel {
    width: 628px;
    box-shadow: 0px 1px 8px 0px rgba(7, 6, 76, 0.31);
    .el-picker-panel__sidebar {
      background-color: #f2f6fc;
      padding: 15px 10px;
      .el-picker-panel__shortcut {
        border-radius: 18px;
        background-color: #ffffff;
        text-align: center;
        margin-bottom: 10px;
        padding: 1px 12px;
        &:hover {
          background-color: #4497ec;
          color: #ffffff;
        }
        &.active {
          background-color: #4497ec;
          color: #ffffff;
        }
      }
    }
  }
  .el-date-editor {
    margin-right: 44px;
    width: auto;
    background-color: #ffffff;
    color: rgba(69, 70, 71, 1);
    border: none;
    .el-input__icon {
      display: none;
    }
    .el-range-input {
      background-color: #ffffff;
    }
    .el-range-separator {
      width: auto;
      color: rgba(69, 70, 71, 1);
      padding: 0 3px;
    }
    &--datetimerange {
      .el-range-input {
        width: 120px;
      }
    }
    &--daterange {
      .el-range-input {
        width: 80px;
        font-size: 14px;
      }
    }
  }
  & > .icon {
    cursor: pointer;
    position: absolute;
    top: 5px;
    right: 0;
  }
}
</style>
